var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1309 19.0605H7.13086C6.72086 19.0605 6.38086 18.7205 6.38086 18.3105C6.38086 17.9005 6.72086 17.5605 7.13086 17.5605H15.1309C17.4709 17.5605 19.3809 15.6505 19.3809 13.3105C19.3809 10.9705 17.4709 9.06055 15.1309 9.06055H4.13086C3.72086 9.06055 3.38086 8.72055 3.38086 8.31055C3.38086 7.90055 3.72086 7.56055 4.13086 7.56055H15.1309C18.3009 7.56055 20.8809 10.1405 20.8809 13.3105C20.8809 16.4805 18.3009 19.0605 15.1309 19.0605Z",
    fill: "#DEDEDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43055 11.5609C6.24055 11.5609 6.05055 11.4909 5.90055 11.3409L3.34055 8.78086C3.05055 8.49086 3.05055 8.01086 3.34055 7.72086L5.90055 5.16086C6.19055 4.87086 6.67055 4.87086 6.96055 5.16086C7.25055 5.45086 7.25055 5.93086 6.96055 6.22086L4.93055 8.25086L6.96055 10.2809C7.25055 10.5709 7.25055 11.0509 6.96055 11.3409C6.82055 11.4909 6.62055 11.5609 6.43055 11.5609Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.726883c42749d0025095830f3b1223aa.svg";
export { ForwardRef as ReactComponent };